import axios from "axios";

const axiosEra = axios.create({
  baseURL: "https://era.easebuzz.in/api/",
  withCredentials: false,
  headers: {},
});

export class ChatModel {
  static submit_question = (queryData = {}, config = {}) => {
    return axiosEra
      .post("submit-question/", queryData, config)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };

  static update_interaction = (queryData = {}, config = {}) => {
    return axiosEra
      .post("update-interaction/", queryData, config)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };

  static update_data = (queryData = {}, config = {}) => {
    return axiosEra
      .post("update-data/", queryData, config)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };

}


export class ChatModelFetch {
  static submit_question = async (queryData = {}, config = {}, onChunkReceived) => {
    try {
      const response = await fetch("https://era.easebuzz.in/api/submit-question/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...config.headers, // Add additional headers from config
        },
        body: JSON.stringify(queryData), // Convert queryData to JSON
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      
      const responseId = response.headers.get("X-Response-Id") ?? "1";

      // Handle streaming response
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let result = ""; // To accumulate all the chunks if needed for final processing

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        // Decode the chunk
        let chunk = decoder.decode(value, { stream: true });

        result += chunk;
        // Call the onChunkReceived callback to process the chunk immediately
        if (onChunkReceived && typeof onChunkReceived === "function") {
          onChunkReceived(chunk); // Pass the processed chunk to the UI immediately
        }
      }

      

      // Optionally, return the final result if needed after all chunks are processed
      return Promise.resolve({ responseId, result });

    } catch (error) {
      console.error("Error during fetch:", error);
      return Promise.reject(error); // Reject if error occurs
    }
  };

  static brd_upload = async (formData ,onChunkReceived) => {
    try {
      const response = await fetch("https://era.easebuzz.in/api/upload-frd/", {
        method: "POST",
        body: formData, // Convert queryData to JSON
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      
      const responseId = response.headers.get("X-Response-Id") ?? "1";

      // Handle streaming response
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let result = ""; // To accumulate all the chunks if needed for final processing

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        // Decode the chunk
        let chunk = decoder.decode(value, { stream: true });

        result += chunk;
        // Call the onChunkReceived callback to process the chunk immediately
        if (onChunkReceived && typeof onChunkReceived === "function") {
          onChunkReceived(chunk); // Pass the processed chunk to the UI immediately
        }
      }

      

      // Optionally, return the final result if needed after all chunks are processed
      return Promise.resolve({ responseId, result });

    } catch (error) {
      console.error("Error during fetch:", error);
      return Promise.reject(error); // Reject if error occurs
    }
  };

  static code_genie = async (formData ,onChunkReceived) => {
    try {
      const response = await fetch("https://era.easebuzz.in/api/code-analysis/", {
        method: "POST",
        body: formData, // Convert queryData to JSON
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      
      const responseId = response.headers.get("X-Response-Id") ?? "1";

      // Handle streaming response
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let result = ""; // To accumulate all the chunks if needed for final processing

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        // Decode the chunk
        let chunk = decoder.decode(value, { stream: true });

        result += chunk;
        // Call the onChunkReceived callback to process the chunk immediately
        if (onChunkReceived && typeof onChunkReceived === "function") {
          onChunkReceived(chunk); // Pass the processed chunk to the UI immediately
        }
      }

      

      // Optionally, return the final result if needed after all chunks are processed
      return Promise.resolve({ responseId, result });

    } catch (error) {
      console.error("Error during fetch:", error);
      return Promise.reject(error); // Reject if error occurs
    }
  };

  static buzz_reports = async (queryData = {}, config = {}) => {
    try {
      const response = await fetch("https://era.easebuzz.in/api/buzz-reports/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...config.headers, // Add additional headers from config
        },
        body: JSON.stringify(queryData), 
      });
  
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
  
      // Read the JSON response directly
      const jsonResponse = await response.json();
      
      return Promise.resolve(jsonResponse);
  
    } catch (error) {
      console.error("Error during fetch:", error);
      return Promise.reject(error); // Reject if error occurs
    }
  };

  static era_v2_api = async (queryData = {}, config = {}, onChunkReceived) => {
    try {
      const response = await fetch("https://era.easebuzz.in/api/v2/submit-question/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...config.headers, // Add additional headers from config
        },
        body: JSON.stringify(queryData), // Convert queryData to JSON
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      
      const responseId = response.headers.get("X-Response-Id") ?? "1";

      // Handle streaming response
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let result = ""; // To accumulate all the chunks if needed for final processing
      let isDone = false;
      while (!isDone) {
        const { done, value } = await reader.read();
        if (done) isDone = true;

        // Decode the chunk
        let chunk = decoder.decode(value, { stream: true });

        result += chunk;
        // Call the onChunkReceived callback to process the chunk immediately
        if (onChunkReceived && typeof onChunkReceived === "function") {
          onChunkReceived(chunk, done); // Pass the processed chunk to the UI immediately
        }
      }

      

      // Optionally, return the final result if needed after all chunks are processed
      return Promise.resolve({ responseId, result });

    } catch (error) {
      console.error("Error during fetch:", error);
      return Promise.reject(error); // Reject if error occurs
    }
  };
  

}

